var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab-ul"},[_c('ul',_vm._l((_vm.tabData),function(item){return _c('li',{key:item.path,class:item.path === _vm.activeProduct ? 'active' : ''},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }